const initState = {
  successFetching: false,
  errorFetching: false,
  document: null,
  documents: null,
  pdf:null
};

export default initState;
